
export const baseUrl="https://api.themoviedb.org/3";
export const apiKey="a4d9275e67d051c400e305bc8af6054f";
export const imageUrl="https://image.tmdb.org/t/p/original";

